import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Button,
  Switch,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const EventDetailsTab = ({
  isMobile,
  event,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  listed,
  setListed,
  capacity,
  setCapacity,
  eventType,
  setEventType,
  questionGroup,
  setQuestionGroup,
  questionGroups,
}) => {
  return (
    <>
      {/* Other fields and components */}

      {/* End DateTimePicker grid */}
      <Grid item>
        {/* End DateTimePicker component */}
      </Grid>
      {/* </LocalizationProvider> */}
      
      {/* Capacity */}
      <Grid item>
        <TextField
          style={{ width: isMobile ? "100%" : "25%" }}
          label="Capacity *"
          type="number"
          inputProps={{ step: 1 }}
          value={capacity}
          onChange={(e) => setCapacity(e.target.value)}
        />
      </Grid>

      {/* Event type (only when creating new event) */}
      {!event && (
        <Grid item>
          <FormControl style={{ width: isMobile ? "100%" : "25%" }}>
            <InputLabel id="event-type-label">Event Type</InputLabel>
            <Select
              labelId="event-type-label"
              value={eventType}
              label="Event Type"
              onChange={(e) => setEventType(e.target.value)}
              fullWidth
            >
              <MenuItem value="hetero">Hetero</MenuItem>
              <MenuItem value="menseekingmen">Men Seeking Men</MenuItem>
              <MenuItem value="lesbian">Lesbian</MenuItem>
              <MenuItem value="lgbtq">LQBTQ</MenuItem>
              <MenuItem value="openspectrum">Open Spectrum</MenuItem>
              <MenuItem value="friend">Friend</MenuItem>
              <MenuItem value="mixer">Mixer</MenuItem>
              <MenuItem value="group">Group</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}

      {/* Question group (only when creating new event) */}
      {!event && (
        <Grid item>
          <FormControl style={{ width: isMobile ? "100%" : "25%" }}>
            <InputLabel id="question-group-label">Question Group</InputLabel>
            <Select
              labelId="question-group-label"
              value={questionGroup}
              label="Question Group"
              onChange={(e) => setQuestionGroup(e.target.value)}
              fullWidth
            >
              {questionGroups.map((group) => (
                <MenuItem key={group._id} value={group._id}>
                  {group.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}

      {/* Other fields and components */}
    </>
  );
};

export default EventDetailsTab;
